import MenuProtocoloType from './types'


export const setTipo = (value) => ({
    type: MenuProtocoloType.TIPO,
    payload: { tipo:value }
})
